import { useTranslation } from "react-i18next";

export const NOMBRE_COLUMNAS_ASIGNACION = {
    NUMERO_DOCUMENTO: "NUMERO_DOCUMENTO",
    CODIGO_CLIENTE: "CODIGO_CLIENTE",
    NOMBRE_CLIENTE: "NOMBRE_CLIENTE",
    LATITUD_CLIENTE: "LATITUD_CLIENTE",
    LONGITUD_CLIENTE: "LONGITUD_CLIENTE",
    DIRECCION_CLIENTE: "DIRECCION_CLIENTE",
    TELEFONO_CLIENTE: "TELEFONO_CLIENTE",
    FECHA_FACTURA: "FECHA_FACTURA",
    NUMERO_FACTURA: "NUMERO_FACTURA",
    VALOR_FACTURA: "VALOR_FACTURA",
    CODIGO_ALMACEN: "CODIGO_ALMACEN",
    NOMBRE_ALMACEN: "NOMBRE_ALMACEN",
    LATITUD_ALMACEN: "LATITUD_ALMACEN",
    LONGITUD_ALMACEN: "LONGITUD_ALMACEN",
    CODIGO_PRODUCTO: "CODIGO_PRODUCTO",
    NOMBRE_PRODUCTO: "NOMBRE_PRODUCTO",
    UNIDAD_MEDIDA: "UNIDAD_MEDIDA",
    CANTIDAD: "CANTIDAD",
    PESO: "PESO",
    VOLUMEN: "VOLUMEN",
    MONTO: "MONTO",
    MONEDA: "MONEDA",
    CODIGO_VENDEDOR: "CODIGO_VENDEDOR",
    NOMBRE_VENDEDOR: "NOMBRE_VENDEDOR",
    REGION: "REGION",
    FECHA_ENTREGA: "FECHA_ENTREGA",
    NUMERO_EMBARQUE: "NUMERO_EMBARQUE",
    TIPO_SERVICIO: "TIPO_SERVICIO",
    ESTADO_PAGO: "ESTADO_PAGO",
    TELEFONOS_NOTIFICACION: "TELEFONOS_NOTIFICACION",
    CORREOS_NOTIFICACION: "CORREOS_NOTIFICACION",
    PREFIJO: "PREFIJO",
    OBSERVACIONES: "OBSERVACIONES",
    FECHA_PROGRAMACION_SALIDA: "FECHA_PROGRAMACION_SALIDA",
    FECHA_CARGUIO: "FECHA_CARGUIO",
};

export const INDEX_COLUMNAS_ASIGNACION = {
    NUMERO_DOCUMENTO: 0,
    CODIGO_CLIENTE: 1,
    NOMBRE_CLIENTE: 2,
    LATITUD_CLIENTE: 3,
    LONGITUD_CLIENTE: 4,
    DIRECCION_CLIENTE: 5,
    TELEFONO_CLIENTE: 6,
    FECHA_FACTURA: 7,
    NUMERO_FACTURA: 8,
    VALOR_FACTURA: 9,
    CODIGO_ALMACEN: 10,
    NOMBRE_ALMACEN: 11,
    LATITUD_ALMACEN: 12,
    LONGITUD_ALMACEN: 13,
    CODIGO_PRODUCTO: 14,
    NOMBRE_PRODUCTO: 15,
    UNIDAD_MEDIDA: 16,
    CANTIDAD: 17,
    PESO: 18,
    VOLUMEN: 19,
    MONTO: 20,
    MONEDA: 21,
    CODIGO_VENDEDOR: 22,
    NOMBRE_VENDEDOR: 23,
    REGION: 24,
    FECHA_ENTREGA: 25,
    NUMERO_EMBARQUE: 26,
    TIPO_SERVICIO: 27,
    ESTADO_PAGO: 28,
    TELEFONOS_NOTIFICACION: 29,
    CORREOS_NOTIFICACION: 30,
    PREFIJO: 31,
    OBSERVACIONES: 32,
    FECHA_PROGRAMACION_SALIDA: 33,
    FECHA_CARGUIO: 34,
};

export const useListaRequerimientosAsignacion = () => {
    const { t } = useTranslation();
    const LISTA_REQUERIMIENTOS_ASIGNACION = [
        {
            index: INDEX_COLUMNAS_ASIGNACION.NUMERO_DOCUMENTO,
            value: NOMBRE_COLUMNAS_ASIGNACION.NUMERO_DOCUMENTO,
            label: t("label_numero_documento"),
            descripcion: t("label_numero_documento"),
            verMas: false,
            obligatorio: true,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.CODIGO_CLIENTE,
            value: NOMBRE_COLUMNAS_ASIGNACION.CODIGO_CLIENTE,
            label: t("label_codigo_cliente"),
            descripcion: t("label_codigo_cliente"),
            verMas: false,
            obligatorio: true,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.NOMBRE_CLIENTE,
            value: NOMBRE_COLUMNAS_ASIGNACION.NOMBRE_CLIENTE,
            label: t("label_nombre_cliente"),
            descripcion: t("label_nombre_cliente"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.LATITUD_CLIENTE,
            value: NOMBRE_COLUMNAS_ASIGNACION.LATITUD_CLIENTE,
            label: t("label_latitud_cliente"),
            descripcion: t("label_latitud_cliente"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.LONGITUD_CLIENTE,
            value: NOMBRE_COLUMNAS_ASIGNACION.LONGITUD_CLIENTE,
            label: t("label_longitud_cliente"),
            descripcion: t("label_longitud_cliente"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.DIRECCION_CLIENTE,
            value: NOMBRE_COLUMNAS_ASIGNACION.DIRECCION_CLIENTE,
            label: t("label_direccion_cliente"),
            descripcion: t("label_direccion_cliente"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.TELEFONO_CLIENTE,
            value: NOMBRE_COLUMNAS_ASIGNACION.TELEFONO_CLIENTE,
            label: t("label_telefono_cliente"),
            descripcion: t("label_telefono_cliente"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.FECHA_FACTURA,
            value: NOMBRE_COLUMNAS_ASIGNACION.FECHA_FACTURA,
            label: t("label_fecha_factura"),
            descripcion: t("label_fecha_factura"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.NUMERO_FACTURA,
            value: NOMBRE_COLUMNAS_ASIGNACION.NUMERO_FACTURA,
            label: t("label_numero_factura"),
            descripcion: t("label_numero_factura"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.VALOR_FACTURA,
            value: NOMBRE_COLUMNAS_ASIGNACION.VALOR_FACTURA,
            label: t("label_valor_factura"),
            descripcion: t("label_valor_factura"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.CODIGO_ALMACEN,
            value: NOMBRE_COLUMNAS_ASIGNACION.CODIGO_ALMACEN,
            label: t("label_codigo_almacen"),
            descripcion: t("label_codigo_almacen"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.NOMBRE_ALMACEN,
            value: NOMBRE_COLUMNAS_ASIGNACION.NOMBRE_ALMACEN,
            label: t("label_nombre_almacen"),
            descripcion: t("label_nombre_almacen"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.LATITUD_ALMACEN,
            value: NOMBRE_COLUMNAS_ASIGNACION.LATITUD_ALMACEN,
            label: t("label_latitud_almacen"),
            descripcion: t("label_latitud_almacen"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.LONGITUD_ALMACEN,
            value: NOMBRE_COLUMNAS_ASIGNACION.LONGITUD_ALMACEN,
            label: t("label_longitud_almacen"),
            descripcion: t("label_longitud_almacen"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.CODIGO_PRODUCTO,
            value: NOMBRE_COLUMNAS_ASIGNACION.CODIGO_PRODUCTO,
            label: t("label_codigo_producto"),
            descripcion: t("label_codigo_producto"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.NOMBRE_PRODUCTO,
            value: NOMBRE_COLUMNAS_ASIGNACION.NOMBRE_PRODUCTO,
            label: t("label_nombre_producto"),
            descripcion: t("label_nombre_producto"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.UNIDAD_MEDIDA,
            value: NOMBRE_COLUMNAS_ASIGNACION.UNIDAD_MEDIDA,
            label: t("label_unidad_medida"),
            descripcion: t("label_unidad_medida"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.CANTIDAD,
            value: NOMBRE_COLUMNAS_ASIGNACION.CANTIDAD,
            label: t("label_cantidad"),
            descripcion: t("label_cantidad"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.PESO,
            value: NOMBRE_COLUMNAS_ASIGNACION.PESO,
            label: t("label_peso"),
            descripcion: t("label_peso"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.VOLUMEN,
            value: NOMBRE_COLUMNAS_ASIGNACION.VOLUMEN,
            label: t("label_volumen"),
            descripcion: t("label_volumen"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.MONTO,
            value: NOMBRE_COLUMNAS_ASIGNACION.MONTO,
            label: t("label_monto"),
            descripcion: t("label_monto"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.MONEDA,
            value: NOMBRE_COLUMNAS_ASIGNACION.MONEDA,
            label: t("label_moneda"),
            descripcion: t("label_moneda"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.CODIGO_VENDEDOR,
            value: NOMBRE_COLUMNAS_ASIGNACION.CODIGO_VENDEDOR,
            label: t("label_codigo_vendedor"),
            descripcion: t("label_codigo_vendedor"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.NOMBRE_VENDEDOR,
            value: NOMBRE_COLUMNAS_ASIGNACION.NOMBRE_VENDEDOR,
            label: t("label_nombre_vendedor"),
            descripcion: t("label_nombre_vendedor"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.REGION,
            value: NOMBRE_COLUMNAS_ASIGNACION.REGION,
            label: t("label_region"),
            descripcion: t("label_region"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.FECHA_ENTREGA,
            value: NOMBRE_COLUMNAS_ASIGNACION.FECHA_ENTREGA,
            label: t("label_fecha_entrega"),
            descripcion: t("label_fecha_entrega"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.NUMERO_EMBARQUE,
            value: NOMBRE_COLUMNAS_ASIGNACION.NUMERO_EMBARQUE,
            label: t("label_numero_embarque"),
            descripcion: t("label_numero_embarque"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.TIPO_SERVICIO,
            value: NOMBRE_COLUMNAS_ASIGNACION.TIPO_SERVICIO,
            label: t("label_tipo_servicio"),
            descripcion: t("label_tipo_servicio"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.ESTADO_PAGO,
            value: NOMBRE_COLUMNAS_ASIGNACION.ESTADO_PAGO,
            label: t("label_estado_pago"),
            descripcion: t("label_estado_pago"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.TELEFONOS_NOTIFICACION,
            value: NOMBRE_COLUMNAS_ASIGNACION.TELEFONOS_NOTIFICACION,
            label: t("label_telefonos_notificacion"),
            descripcion: t("label_telefonos_notificacion"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.CORREOS_NOTIFICACION,
            value: NOMBRE_COLUMNAS_ASIGNACION.CORREOS_NOTIFICACION,
            label: t("label_correos_notificacion"),
            descripcion: t("label_correos_notificacion"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.PREFIJO,
            value: NOMBRE_COLUMNAS_ASIGNACION.PREFIJO,
            label: t("label_prefijo"),
            descripcion: t("label_prefijo"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.OBSERVACIONES,
            value: NOMBRE_COLUMNAS_ASIGNACION.OBSERVACIONES,
            label: t("label_observaciones"),
            descripcion: t("label_observaciones"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.FECHA_PROGRAMACION_SALIDA,
            value: NOMBRE_COLUMNAS_ASIGNACION.FECHA_PROGRAMACION_SALIDA,
            label: t("label_fecha_programacion_salida"),
            descripcion: t("label_fecha_programacion_salida"),
            verMas: false,
            obligatorio: false,
        },
        {
            index: INDEX_COLUMNAS_ASIGNACION.FECHA_CARGUIO,
            value: NOMBRE_COLUMNAS_ASIGNACION.FECHA_CARGUIO,
            label: t("label_fecha_carguio"),
            descripcion: t("label_fecha_carguio"),
            verMas: false,
            obligatorio: false,
        },
    ];
    return LISTA_REQUERIMIENTOS_ASIGNACION;
};
